import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import './App.css';
// import EmptyState from './components/EmptyState/EmptyState';
import { Suspense, lazy } from 'react';
import theme from './theme';
import DashboardRoutes from './routes/DashboardRoutes';
// import FeedbackList from './pages/Feedback/FeedbackList';
// import AdminRoutes from './routes/AdminRoutes';
import AuthRoutes from './routes/AuthRoutes';
import PublicRoutes from './routes/PublicRoutes';
import PageLoader from './components/Loader/PageLoader';
import Landing from './pages/Landing';
import Welcome from './pages/Welcome';
import VehicleHistory from './pages/VehicleHistory';
import DTCQuery from './pages/DTCQuery';
import DIDQuery from './pages/DIDQuery';
import ConcernQuery from './pages/ConcernQuery';
import ApplicationQuery from './pages/ApplicationQuery';
import Callback from './pages/Callback';
import Disclaimer from './pages/Disclaimer';

// const PrivateRoutes = lazy(() => import('./routes/PrivateRoutes'));
const Login = lazy(() => import('./pages/Login'));
// const Signup = lazy(() => import('./pages/Signup'));
// const Account = lazy(() => import('./pages/Account/Account'));
// const UserManual = lazy(() => import('./pages/UserManual'));

function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <div className="App">
        <ConfigProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicRoutes />}>
                <Route path="/" element={<Navigate to="/login" />} />
                <Route path="/login" element={<Landing />} />
                <Route path="/callback" element={<Callback />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
              </Route>
              <Route path="/dashboard" element={<DashboardRoutes />}>
                <Route path="/dashboard" element={<Welcome />} />
                <Route path="/dashboard/vehiclehistory" element={<VehicleHistory />} />
                <Route path="/dashboard/dtcquery" element={<DTCQuery />} />
                <Route path="/dashboard/didquery" element={<DIDQuery />} />
                <Route path="/dashboard/concernquery" element={<ConcernQuery />} />
                <Route path="/dashboard/applicationquery" element={<ApplicationQuery />} />
              </Route>
              {/* <Route path="/" element={<AuthRoutes />}>
                <Route path="/login" element={<Landing />} />
              </Route> */}
            </Routes>
          </BrowserRouter>
        </ConfigProvider>
      </div>
    </Suspense>
  );
}

export default App;
